// extracted by mini-css-extract-plugin
export default {"col_M":"index_col_M_eKO0p","cattle_stocks":"index_cattle_stocks_q2pat","space16":"index_space16_Od88f","space20":"index_space20_21Mao"};